module.exports = __webpack_public_path__ + "static/media/girl-16.7cd194ad.svg";